import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { RuleConfigUpdateInput } from 'shared';

import { updateRule } from '../../lib/api/endpoints';

import { rulesKeys } from './queries';

export function useUpdateRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { key: string; body: RuleConfigUpdateInput }) =>
      updateRule(input.key, input.body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: rulesKeys.all });
    },
  });
}
